export default "__VITE_ASSET__BthZWVTI__"